<ng-container *ngIf="isLoadingLessorStakeholder === false">

  <div class="contents">
    <div class="form_input">
      <h2 class="title">Stakeholder</h2>

      <form [formGroup]="lessorStakeholderForm">
        <div class="input">
          <label for="">Name</label>
          <input type="text"  (click)="onSearchDialog()" formControlName="Name"  class="default_input reference-form" />
        </div>

        <div class="input">
          <label for="">Phone</label>
          <input type="number" formControlName="PhoneNo" class="default_input reference-form" />
        </div>

        <div class="input">
          <label for="">Address</label>
          <input type="text" formControlName="Address" class="default_input reference-form" />
        </div>

        <div class="input">
          <label for="">Account Number</label>
          <input type="number" formControlName="AccountNo" class="default_input reference-form" />
        </div>

        <div class="input">
          <label for="">Bank</label>
          <select formControlName="BankId" class="default_input reference-form">
            <option *ngFor="let bank of banks"
            [value]="bank.id">{{ bank.BankName }}</option>
          </select>
        </div>

      </form>
      <div class="btn_holder">
        <button class="default_primary-button" (click)="addNew(lessorStakeholderForm.getRawValue())" type="submit">
          <ng-container *ngIf="selectedIndex === null">
            Add  &rarr;
          </ng-container>
          <ng-container *ngIf="selectedIndex !== null">
            Update  &rarr;
          </ng-container>
        </button>

        <div class="refresh">
          <button mat-button (click)="onReset()">
             <i class="material-icons">
              settings_backup_restore
              </i>Reset</button>
          </div>
      </div>
    </div>

<cradua-stakeholder-table
[lessorStakeholders]="lessorStakeholders"
[selectedLessorInfo]="selectedLessorInfo"
[addressBook]="addressBook"
[banks]="banks"
(emitEdit)="onEdit($event)"
>
</cradua-stakeholder-table>
</div>

<div class="acquisition_submit">
<button class="default_primary-button" (click)="onSubmit()" type="submit">
Save
</button>
<button class="default_secondary-btn ml-2" (click)="onBack()"> <i class="ti-arrow-left"></i> Back</button>

</div>
</ng-container>
<cradua-list-spinner
*ngIf="isLoadingLessorStakeholder === true"
>
</cradua-list-spinner>
